module.exports = __webpack_public_path__ + "img/give.9f7a852e.png";